import {GoingUtils} from "goingutils";

export default  function _initQueryPanelByDxCell(moreQueryPanelId, panelContainer) {
    let zIndex = GoingUtils.getCurMaxZIndex()||GoingUtils.getMaxZIndex();

    $(`<div id="${moreQueryPanelId}" class="go-more-query animated" style="z-index: ${zIndex}">
             <div class="query-panel-title">多条件查询</div>
                <div class="query-panel-body" style="overflow: auto;height:calc(100% - 75px);" id="${moreQueryPanelId}_body">
                     
                </div>
            <div class="query-bottom-btns"  style="position: absolute; bottom: 0;height: 40px;width:100%">
                <div class="dialog-bt-bar">
                    <div class="go-tool-bar clearfix" style="height:40px;"> 
                       <div btnid="confirmBtn" id="${moreQueryPanelId}_confirm" class="pull-right go-btn-simple no-padding primary">确定</div>
                       <div btnid="clearBtn" id="${moreQueryPanelId}_clearBtn" class="pull-right go-btn-simple no-padding primary">清空</div>
                       <div btnid="cancelBtn" id="${moreQueryPanelId}_cancelBtn" class="pull-right go-btn-simple no-padding gray">取消</div>  
                    </div>
                </div>
            </div>
    </div>`).appendTo(panelContainer);
    return moreQueryPanelId;
}



// WEBPACK FOOTER //
// ./goingsrc/common/initQueryPanelByDxCell.js